import React from "react"
import Layout from "../components/layout"
import * as aboutStyles from "../styles/about.module.css"
export default function About() {
  return (
    <Layout>

      {/* Among US Image */}

      <div className={aboutStyles.landing}></div>

      {/* Who are We?  */}

      <div className={aboutStyles.container}>
        <h3>WHO ARE WE?</h3>
        <p>
          We are just like you, college folks, confused about what to do in
          life. We’ve always yearned for a one place destination which has
          answers to all our questions like: how to get started in a field, what
          are the prospects of staying in it, what are the exit options? And
          that is why we spent some time talking to various BITSians in
          different fields, hearing their experiences to help unravel answers to
          these questions. And now we think it’s the right time to bring all
          that we’ve learnt to you.
        </p>
      </div>

      {/* Team Grid */}

      <div className={aboutStyles.teamContainer}>
        <div className={aboutStyles.teamWrapper}>
          <h3>Meet Us</h3>
          <div className={aboutStyles.teamGrid}>
            <div className={aboutStyles.person}>
              <img src={"/manisha.jpg"} width="160px" height="200px" />
              <div>
                <p>Manisha Garg</p>
                <p>MSc. Economics</p>
                <p>B.E. Computer Science</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>
            <div className={aboutStyles.person}>
              <img src={"/nikita.jpg"} width="200px" height="200px" />
              <div>
                <p>Nikita Saxena</p>
                <p>MSc. Physics</p>
                <p>B.E. Computer Science</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>
            <div className={aboutStyles.person}>
              <img src={"/rishika.jpg"} width="180px" height="200px" />
              <div>
                <p>Rishika Jain</p>
                <p>MSc. Biology</p>
                <p>B.E. Computer Science</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>
            <div className={aboutStyles.person}>
              <img src={"/nishika.jpg"} width="210px" height="200px" />
              <div>
                <p>Nishika Gupta</p>
                <p>MSc. Mathematics</p>
                <p>B.E. Computer Science</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>

            <div className={aboutStyles.person}>
              <img src={"/sunidhi.jpg"} width="130px" height="200px" />
              <div>
                <p>Sunidhi Garg</p>
                <p>MSc. Mathematics</p>
                <p>B.E. Chemical</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>
            <div className={aboutStyles.person}>
              <img src={"/nihir.jpg"} width="150px" height="200px" />
              <div>
                <p>Nihir Agarwal</p>
                <p>MSc. Mathematics</p>
                <p>B.E. Computer Science</p>
                <p>BITS Pilani’23</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
